<style lang="scss">



@media screen and (min-width: 55rem) {
  .membershipstorenew-container {
    margin-top: 5rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .membershipbannerright {
      max-width: 1080px;
      width: 80%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      background-color: white;

      .membershipstorebannercontent-list {
        margin-top: 5rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        .membershipstorebannercontent-list-item {
          display: flex;
          flex-direction: column;
          align-items: center;

          .membershipstorebannercontent-item-title {
            font-size: 1.3125rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 500;
            color: #4b4b4b;
            line-height: 1.5625rem;
            margin-top: 1rem;
            margin-bottom: 1rem;
          }
          .membershipstorebannercontent-item-span {
            font-size: 1rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #7f7f7f;
            line-height: 17px;
            width: 150px;
          }
          .membershipstorebannercontent-item {
            width: 6rem;
            height: 6rem;
            background-image: url("/media/yintai/membership-6.png");
            background-size: 100% 100%;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 55rem) {
  .membershipstorenew-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 5rem;
    .membershipbannerright {
      width: 80%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .membershipstorebannercontent-list {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        .membershipstorebannercontent-list-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .membershipstorebannercontent-item-title {
            font-size: 1.3125rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 500;
            color: #4b4b4b;
            line-height: 1.5625rem;
            margin-top: 1rem;
            margin-bottom: 1rem;
          }
          .membershipstorebannercontent-item-span {
            font-size: 1rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #7f7f7f;
            line-height: 17px;
            width: 121px;
            height: 7rem;

            // font-size: 1rem;
            // font-family: 'PingFang SC','Microsoft YaHei';
            // font-weight: 400;
            // color: #0d131a;
          }
          .membershipstorebannercontent-item {
            width: 5rem;
            height: 5rem;
            background-image: url("/media/yintai/membership-6.png");
            background-size: 100% 100%;
          }
        }
        .membershipstorebannercontent-icon {
          width: 2rem;
          height: 2rem;
          background-image: url("/media/yintai/membership-left.png");
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>

<template>
  <div class="membershipstorenew-container">
    <div class="membershipbannerright">
      <div class="membershipstorebannercontent-list">
        <div class="container">
          <div class="row">
            <div
              class="col-6 col-sm-6 col-md-3 col-lg-3 membershipstorebannercontent-list-item"
            >
              <div
                class="membershipstorebannercontent-item"
                style="
                  background-image: url('/media/yintai//cloudstore-new-1.png');
                "
              ></div>
              <div class="membershipstorebannercontent-item-title">新工具</div>
              <div class="membershipstorebannercontent-item-span">
                数智化升级以来 银泰百货对数字商业的实践和探索
              </div>
            </div>
            <div
              class="col-6 col-sm-6 col-md-3 col-lg-3 membershipstorebannercontent-list-item"
            >
              <div
                class="membershipstorebannercontent-item"
                style="
                  background-image: url('/media/yintai//cloudstore-new-2.png');
                "
              ></div>
              <div class="membershipstorebannercontent-item-title">新方法</div>
              <div class="membershipstorebannercontent-item-span">
                以大数据为驱动来解决下沉市场因商品力分布不均而出现的购物难的问题
              </div>
            </div>
            <div
              class="col-6 col-sm-6 col-md-3 col-lg-3 membershipstorebannercontent-list-item"
            >
              <div
                class="membershipstorebannercontent-item"
                style="
                  background-image: url('/media/yintai/cloudstore-new-3.png');
                "
              ></div>
              <div class="membershipstorebannercontent-item-title">新模式</div>
              <div class="membershipstorebannercontent-item-span">
                云货架、导购员、 实体空间的固定模块 快速落地在多个不同场景
              </div>
            </div>
            <div
              class="col-6 col-sm-6 col-md-3 col-lg-3 membershipstorebannercontent-list-item"
            >
              <div
                class="membershipstorebannercontent-item"
                style="
                  background-image: url('/media/yintai/cloudstore-new-4.png');
                "
              ></div>
              <div class="membershipstorebannercontent-item-title">新体系</div>
              <div class="membershipstorebannercontent-item-span">
                前瞻性地创造了完整的顾客消费心智教育体系
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "membershipstorenew",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
